export const ON_USER_INTERACTION = '/common/hooks/ON_USER_INTERACTION';

export const onUserInteractionAction = currentLoggedActionID => ({
    type: ON_USER_INTERACTION,
    payload: currentLoggedActionID,
});
